/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

export const patientsHeaderCsv = [
  { label: "Date Added", key: "date" },
  { label: "Last Name", key: "lastName" },
  { label: "First Name", key: "firstName" },
  { label: "Age", key: "age" },
  { label: "Gender", key: "gender" },
  { label: "MRN", key: "mrn" },
  { label: "Email", key: "email" },
  { label: "Following", key: "following" },
  { label: "Home Phone", key: "homePhone" },
  { label: "Mobile Phone", key: "mobilePhone" },
  { label: "Locations", key: "location" },
];

export const insuranceHeaderCsv = [
  { label: "Date Added", key: "date" },
  { label: "Last Name", key: "lastName" },
  { label: "First Name", key: "firstName" },
  { label: "Age", key: "age" },
  { label: "Gender", key: "gender" },
  { label: "Home Phone", key: "homePhone" },
  { label: "Mobile Phone", key: "mobilePhone" },
  { label: "Insurance Name", key: "insurance" },
  { label: "Policy #", key: "policy" },
  { label: "Group #", key: "group" },
  { label: "Subscriber Name", key: "subscriber" },
  { label: "Subscriber DOB", key: "subscriberDob" },
  { label: "Physician", key: "physician" },
];

export const missedDueHeaderCsv = [
  { label: "Status", key: "status" },
  { label: "Last Name, First Name", key: "name" },
  { label: "Device Manufacturer", key: "device" },
  { label: "Device Type", key: "deviceType" },
  { label: "Billing Cycle", key: "billing" },
  { label: "Phone", key: "phone" },
  { label: "Last PE Note", key: "note" },
  { label: "Days Left", key: "daysLeft" },
];

export const preAuthHeaderCsv = [
  { label: "Last, First", key: "name" },
  { label: "DOB", key: "dob" },
  { label: "MRN", key: "mrn" },
  { label: "Device Type", key: "deviceType" },
  { label: "Payer Type", key: "payerType" },
  { label: "Insurance Type", key: "insuranceType" },
  { label: "cpt30", key: "cptThree" },
  { label: "30DOS", key: "threeDos" },
  { label: "cpt90", key: "cptNine" },
  { label: "90DOS", key: "nineDos" },
  { label: "Insurance Policy Name", key: "insuranceName" },
  { label: "Policy #", key: "policy" },
  { label: "Group #", key: "group" },
  { label: "Last Preauth30", key: "preauthThree" },
  { label: "Last Preauth90", key: "preauthNine" },
];

export const patientEngagementHeaderCsv = [
  { label: "Date/Time Request Submitted", key: "requested" },
  { label: "Submitted by", key: "createdBy" },
  { label: "Last Name, First Name", key: "name" },
  { label: "Date of birth", key: "dob" },
  { label: "Device Manufacturer", key: "device" },
  { label: "Device Type", key: "deviceType" },
  { label: "Phone", key: "phone" },
  { label: "Reserved by", key: "assigned" },
  { label: "Last PE Note", key: "note" },
  { label: "Reason", key: "reason" },
  { label: "Location", key: "location" },
  { label: "Date Closed", key: "dateClosed" },
  { label: "Closed By", key: "closedBy" },
];
